
import React, { useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Row, Col } from "antd";
import { SalesLines } from "./inc/Components";
import moment from 'moment';
import { currencyFormat, capitalizeFirstLetter, displayPan } from "../../../../../helpers/utilities";
import FileUpload from "../../FileUpload";


export const BTST1 = React.forwardRef((props, ref) => {
    const { businessDetails, details, preview, proformaPreview, form } = props;
    const classes = customStyles();
    const topSec = useRef('');

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    const discountAmount = (items) => {
        const safeItems = items ?? [];
if (!safeItems.length) return 0;
        let totalDiscount = Number(details?.cashDiscountAmount || 0);
        for (const v of items) {
            const qty = Number(v.quantity || 0);
            const price = Number(v.pricePerUnit || 0);
            const discountAmt = Number(v.discountAmount || 0);
            const discountPercent = Number(v.discountPercent || 0);

            // Line-level fixed discount
            totalDiscount += discountAmt;

            // Percentage discount
            const percentDiscount = ((qty * price) * discountPercent) / 100;

            if (v.amount < 0) {
                totalDiscount -= percentDiscount;
            } else {
                totalDiscount += percentDiscount;
            }
        }

        return Number(totalDiscount.toFixed(2));
    }

    return (
        <div className={classes.formatFirst}>
            <div className={classes.downloadbars}>
                <div className={classes.downloadtopbar}></div>
                {
                    proformaPreview ? <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={classes.downloadsecondbar}>Proforma</div> : <div className={classes.downloadsecondbar}>
                        {
                            preview || details?.invoiceAmount >= 0 ? `${details?.selfBill?.includeGst ? 'Tax Invoice' : 'Invoice'}` : 'Credit Note'
                        }
                        <span>{`${capitalizeFirstLetter(form?.format)}`}</span></div>
                }
            </div>
            <div className={classes.downloaddetails}>
                <div ref={topSec}>
                    <Row>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.billtoppadding, classes.billCustom)}>
                            <Row type="flex" gutter={15}>
                                {
                                    businessDetails?.logoUri &&
                                    <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} className={classes.dispalyIF}>
                                        <div className={clsx(classes.productImageUpload, classes.dropDown)}>
                                            <FileUpload filePath={details?.business?.logoUri || businessDetails?.logoUri || ''} view={true} />
                                        </div>
                                    </Col>
                                }
                                <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                    <h1>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : businessDetails?.businessName || details?.business?.name || '---'}</h1>
                                    <div className={classes.bill}>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(businessDetails || details?.business)}</p>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(businessDetails || details?.business)}</p>
                                    </div>
                                    <Row className={clsx(classes.bill, classes.margin25t)}>
                                        <Col span={24}>
                                            <Row>
                                                <Col span={3}>
                                                    <h6>Email</h6>
                                                </Col>
                                                <Col span={21}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.email || details?.business?.email || '---'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={12}>
                                            <Row>
                                                <Col span={6}>
                                                    <h6>Ph No.</h6>
                                                </Col>
                                                <Col span={18}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.mobile || details?.business?.mobile || '---'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        {
                                            (details?.selfBill?.includeGst || preview) && <Col span={12}>
                                                <Row>
                                                    <Col span={6}>
                                                        <h6>GSTIN</h6>
                                                    </Col>
                                                    <Col span={18}>
                                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.gst || details?.business?.gstNumber || '---'}</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        }
                                        {
                                            (businessDetails?.pan || details?.business?.panNumber) && <Col span={24}>
                                                <Row>
                                                    <Col span={3}>
                                                        <h6>{displayPan(businessDetails?.pan || details?.business?.panNumber || '')[0]}</h6>
                                                    </Col>
                                                    <Col span={21}>
                                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(businessDetails?.pan || details?.business?.panNumber || '')[1]}</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        }
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className={clsx(classes.yellowBorderTop)}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.borderRight, classes.bill, classes.billtoppadding)}>
                            <h6>Bill To</h6>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.customer?.name || '---'}</p>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(details?.customer)}</p>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(details?.customer)}</p>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.bill, classes.billtoppadding)}>
                            <h6>Shipped To</h6>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.customer?.name || '---'}</p>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(details)}</p>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(details)}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} className={clsx(classes.borderRight, classes.bill, classes.billbottompadding)}>
                            <Row>
                                <Col span={24}>
                                    <Row>
                                        <Col span={3}>
                                            <h6>Email</h6>
                                        </Col>
                                        <Col span={21}>
                                            <p className={clsx(classes.emailText)}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.email || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <h6>Ph No.</h6>
                                        </Col>
                                        <Col span={18}>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.mobile || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    (details?.selfBill?.includeGst || preview) &&
                                    <Col span={12}>
                                        <Row>
                                            <Col span={6}>
                                                <h6>GSTIN</h6>
                                            </Col>
                                            <Col span={18}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.gstin || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                {
                                    details?.customer?.pan && <Col span={24}>
                                        <Row>
                                            <Col span={3}>
                                                <h6>{displayPan(details?.customer?.pan)[0]}</h6>
                                            </Col>
                                            <Col span={21}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(details?.customer?.pan)[1]}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                            </Row>
                        </Col>
                        <Col span={12} className={clsx(classes.bill, classes.billbottompadding)}>
                            <Row>
                                <Col span={24}>
                                    <Row>
                                        <Col span={3}>
                                            <h6>Email</h6>
                                        </Col>
                                        <Col span={21}>
                                            <p className={clsx(classes.emailText)}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.email || details?.selfBill?.email || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <h6>Ph No.</h6>
                                        </Col>
                                        <Col span={18}>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.phone || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    (details?.selfBill?.includeGst || preview) &&
                                    <Col span={12}>
                                        <Row>
                                            <Col span={6}>
                                                <h6>GSTIN</h6>
                                            </Col>
                                            <Col span={18}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.gstin || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                {
                                    details?.customer?.pan && <Col span={24}>
                                        <Row>
                                            <Col span={3}>
                                                <h6>{displayPan(details?.customer?.pan)[0]}</h6>
                                            </Col>
                                            <Col span={21}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(details?.customer?.pan)[1]}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                            </Row>
                        </Col>
                    </Row>
                    <Row className={clsx(classes.secondSection, classes.yellowBorderTop)}>
                        <Col span={12} className={clsx(classes.borderRight, classes.bill)}>
                            <Row>
                                <Col span={13} style={{ padding: "0" }}>
                                    <h6>{preview || proformaPreview || details?.invoiceAmount >= 0 ? 'Invoice Number' : 'Credit Note'}</h6>
                                    <h1>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.serialNo || '---'}</h1>
                                </Col>
                                <Col span={6} style={{ padding: "0" }}>
                                    <div>
                                        <h6>Invoice Date</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.invoiceDate ? moment(details.invoiceDate).format('DD MMM YYYY') : '---'}</p>
                                    </div>
                                </Col>
                                <Col span={5} style={{ padding: "0" }}>
                                    <div>
                                        <h6>Due Date</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.dueDate ? moment(details.dueDate).format('DD MMM YYYY') : '---'}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className={clsx(classes.paddingTop15)}>
                                <Col span={13} style={{ padding: "0" }}>
                                    {
                                        (details?.reference || details?.salesQuote?.serialNo) &&
                                        <div>
                                            <h6>Reference</h6>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.reference || details?.salesQuote?.serialNo || '---'}</p>
                                        </div>
                                    }
                                </Col>
                                {
                                    (details?.fromDate || details?.toDate) &&
                                    <Col span={11} className={clsx(classes.paddingZeroLine)}>
                                        <div>
                                            <h6>Service Date</h6>
                                            <p>{details.fromDate && moment(details.fromDate).format('DD MMM YYYY')}{details.toDate && (details.toDate !== details.fromDate) && ` to ${moment(details.toDate).format('DD MMM YYYY')}`} </p>
                                        </div>
                                    </Col>
                                }

                            </Row>
                        </Col>
                        <Col span={12} className={clsx(classes.bill)}>
                            <Row className={clsx()}>
                                <Col span={7}>
                                    <div>
                                        <h6>Invoice Amount</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.invoiceAmount ? details?.invoiceAmount : 0)}`}</p>
                                    </div>
                                </Col>
                                <Col span={6}>
                                    <div>
                                        <h6>Net Amount</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.salesInvoiceItems ? details?.invoiceAmount - (details?.roundOffAmount || 0) - details?.salesInvoiceItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0)}`}
                                        </p>
                                    </div>
                                </Col>
                                {
                                    details?.roundOffAmount !== 0 && <Col span={5}>
                                        <div>
                                            <h6>Round Off</h6>
                                            <p>{currencyFormat(details?.roundOffAmount)}</p>
                                        </div>
                                    </Col>
                                }
                                {
                                    (details?.selfBill?.includeGst || preview) &&
                                    <Col span={6}>
                                        <div>
                                            <h6>GST Amount</h6>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> :
                                                `${currencyFormat(details?.salesInvoiceItems ? details?.salesInvoiceItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0)}`}</p>
                                        </div>
                                    </Col>
                                }
                            </Row>
                            <Row className={clsx(classes.paddingTop15)}>
                                <Col span={7}>
                                    <div>
                                        <h6>Place of Supply</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.state?.name || '---'}</p>
                                    </div>
                                </Col>
                                <Col span={6} style={{ padding: "0" }}>
                                    <div>
                                        <h6>Pmt. Method</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.mop?.method || '---'}</p>
                                    </div>
                                </Col>
                                <Col span={5} style={{ padding: "0" }}>
                                    <div>
                                        <h6>Currency</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.currency?.name || '---'}</p>
                                    </div>
                                </Col>
                                {
                                    discountAmount(details?.salesInvoiceItems) > 0 &&
                                    <Col span={(details?.selfBill?.includeGst || preview) ? 6 : 8}>
                                        <div>
                                            <h6>Discount</h6>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> :
                                                `${currencyFormat(discountAmount(details?.salesInvoiceItems))}`}
                                            </p>
                                        </div>
                                    </Col>
                                }

                            </Row>
                        </Col>
                    </Row>
                    {
                        (details?.dispatchDetails || details?.comments || details?.notes) && <Row className={clsx(classes.secondSection, classes.yellowBorderTop)}>
                            {
                                details?.dispatchDetails && <Col span={5} className={clsx(classes.bill)} style={{ padding: "10px 15px 3px 15px" }}>
                                    <div>
                                        <h6>Dispatch Details</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.dispatchDetails || '---'}</p>
                                    </div>
                                </Col>
                            }
                            {
                                (details?.comments || details?.notes) &&
                                <Col span={details?.dispatchDetails ? 19 : 24} className={clsx(classes.borderLeft, classes.bill)} style={{ padding: "10px 15px 3px 40px" }}>
                                    <div>
                                        <h6>Comments</h6>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.notes || '---'}</p>
                                    </div>
                                </Col>
                            }
                        </Row>
                    }
                </div>
                <div className={clsx(classes.yellowBorderTop)}>
                    <div className={clsx(classes.thirdSection,)}><SalesLines topSec={topSec} ref={ref} {...props} terms={true} /></div>
                </div>
            </div>
        </div>
    )
})